var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "uk@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-493.000000, -1295.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "uk"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(423.000000, 1225.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.57,0.68 L27.44,0.68 L27.44,15 L2.44,2.5 C1.27846437,3.62206314 0.567161766,5.13002466 0.44,6.74 L19.64,16.34 L12.64,16.34 L0.41,10.23 L0.41,12 L9.14,16.36 L0.41,16.36 L0.41,19.49 L30.6,19.49 L30.57,0.68 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.23,45.89 C69.4249195,44.7993071 70.1790681,43.3087964 70.35,41.7 L50.93,32 L57.93,32 L70.39,38.23 L70.39,36.48 L61.39,32 L70.39,32 L70.39,28.87 L40,28.87 L40,47.66 L43.13,47.66 L43.13,33.34 L68.23,45.89 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,0.68 L40,0.68 L40,19.47 L70.42,19.47 L70.42,16.34 L61.42,16.34 L70.42,11.86 L70.42,7.29 C70.42,7.06 70.42,6.84 70.42,6.62 L50.99,16.33 L43.99,16.33 L69.36,3.64 C69.0766687,3.1917619 68.7409722,2.77885527 68.36,2.41 L43.1,15 L43.1,0.68 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.39,28.86 L0.39,32 L9.12,32 L0.39,36.36 L0.39,41 C0.39,41.2 0.39,41.39 0.39,41.59 L19.59,31.99 L26.59,31.99 L1.41,44.58 C1.69252287,45.0318528 2.02825717,45.4481633 2.41,45.82 L27.41,33.33 L27.41,47.65 L30.54,47.65 L30.54,28.86 L0.39,28.86 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#EC5565",
    points: "70.39 28.86 70.39 19.47 39.97 19.47 39.97 0.68 30.57 0.68 30.57 19.47 0.39 19.47 0.39 28.86 30.57 28.86 30.57 47.65 39.97 47.65 39.97 28.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.61,16.34 L0.41,6.74 C0.41,6.92 0.41,7.11 0.41,7.29 L0.41,10.22 L12.64,16.33 L19.61,16.34 Z",
    id: "Shape",
    fill: "#EC5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.93,16.34 L70.36,6.63 C70.256603,5.55852058 69.8926956,4.52859395 69.3,3.63 L43.93,16.32 L50.93,16.34 Z",
    id: "Shape",
    fill: "#EC5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.93,32 L70.35,41.71 C70.362161,41.4768251 70.362161,41.2431749 70.35,41.01 L70.35,38.23 L57.93,32 L50.93,32 Z",
    id: "Shape",
    fill: "#EC5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.61,32 L0.41,41.6 C0.495302165,42.6662602 0.838485596,43.6958105 1.41,44.6 L26.62,32 L19.61,32 Z",
    id: "Shape",
    fill: "#EC5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,15 L68.26,2.42 C67.2042292,1.4364164 65.8556079,0.825322379 64.42,0.68 L43.1,0.68 L43.1,15 Z",
    id: "Shape",
    fill: "#4658A9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#4658A9",
    points: "70.39 36.47 70.39 31.99 61.43 31.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#4658A9",
    points: "70.39 16.34 70.39 11.86 61.43 16.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.46,45.82 C3.6908925,46.9956551 5.32786608,47.6511609 7.03,47.65 L27.44,47.6500015 L27.44,33.33 L2.46,45.82 Z",
    id: "Shape",
    fill: "#4658A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,33.33 L43.1,47.65 L63.75,47.65 C65.4101058,47.6499411 67.0094079,47.0252138 68.23,45.9 L43.1,33.33 Z",
    id: "Shape",
    fill: "#4658A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.44,0.68 L6.36,0.68 C4.886312,0.830283242 3.50581776,1.471227 2.44,2.5 L27.44,15 L27.44,0.68 Z",
    id: "Shape",
    fill: "#4658A9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#4658A9",
    points: "0.39 31.99 0.39 36.35 9.11 31.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#4658A9",
    points: "0.39 11.97 0.39 16.34 9.11 16.34"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.a7757c0edf13d0cedc682e53649cb14c.svg";
export { ForwardRef as ReactComponent };